import {
  Slider as SliderCore,
  SliderBtn,
  SliderCount,
  SliderDots,
  SliderDrag,
  SliderProgress,
} from '@studiometa/ui';

import { importOnInteraction } from '@studiometa/js-toolkit';

import SliderItem from './PreparationSliderItem.js';
import SliderTimer from './PreparationSliderTimer.js';

/**
 * @typedef {object} SliderInterface
 * @property {object} $refs
 */

/**
 * Slider class
 */
export default class PreparationSlider extends SliderCore {
  static config = {
    name: 'PreparationSlider',
    components: {
      SliderBtn,
      SliderCount,
      SliderDots,
      SliderDrag,
      SliderItem,
      SliderProgress,
      SliderTimer,
      Cursor: (app) =>
        importOnInteraction(
          () => import('../../atoms/Cursor/Cursor.js'),
          'PreparationSlider',
          'mouseenter',
          app.$root
        ),
    },
    emits: ['open-panel'],
  };

  /**
   * mounted
   */
  mounted() {
    super.mounted();

    setTimeout(() => {
      const lastUrlSegment = window.location.href.split('/').pop();

      this.$children.SliderItem.forEach((sliderItem, sliderItemIndex) => {
        if (sliderItem.$options.slug === lastUrlSegment) {
          this.goTo(sliderItemIndex);
          this.$emit('open-panel', sliderItem.$el, sliderItemIndex);
        }
      });
    }, 0);
  }

  /**
   * `item-clicked` event pass through
   * @param   {HTMLElement} sliderItem
   * @param   {number} sliderItemIndex
   * @this    {Slider & SliderInterface}
   * @returns {void}
   */
  onSliderItemClicked(sliderItem, sliderItemIndex) {
    this.$emit('open-panel', sliderItem, sliderItemIndex);
  }

  /**
   * onGoto
   * @param {number} index
   */
  onGoto(index) {
    this.$children.SliderTimer[0].goTo(index);
  }
}
